<template>
  <div class="field has-addons summoner-search" :class="{
    'summoner-search--center': center,
    'summoner-search--large': large,
  }">
    
    <p class="control">
      <dropdown ref="dropdown">
        <a class="button is-primary summoner-search__region-switcher">
          <span class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><polygon points="9.293 12.95 10 13.657 15.657 8 14.243 6.586 10 10.828 5.757 6.586 4.343 8"/></svg>
          </span>
          <span>{{ selectedRegion.code.toUpperCase() }}</span>
        </a>
        <div slot="content">
          <menus>
            <v-menu-item v-for="region in regions" :key="region.code" @click.native="setRegion(region)" :click="doNothing" :isActive="selectedRegion.code === region.code">{{ region.code.toUpperCase() }}</v-menu-item>
          </menus>
        </div>
      </dropdown>
    </p>
    <p class="control summoner-search__search-container">
      <input class="input summoner-search__search-field" type="search" placeholder="Find a summoner" @keydown.enter="searchSummoner">
    </p>
  </div>
</template>

<script>
import state from '../state'
import Dropdown from 'vue-blu/src/components/dropdown'
import { Menus, MenuItem } from 'vue-blu/src/components/menu'

export default {
  props: {
    center: {
      type: Boolean,
    },
    large: {
      type: Boolean,
    },
  },
  computed: {
    regions () {
      return state.regions
    },
    selectedRegion () {
      return state.selectedRegion
    },
  },
  components: {
    Dropdown,
    Menus,
    VMenuItem: MenuItem,
  },
  methods: {
    setRegion (region) {
      state.selectedRegion = region

      setTimeout(() => {
        this.$refs.dropdown.hidePopper()
      }, 50)
    },
    searchSummoner (e) {
      let region = this.selectedRegion.code
      let name = e.target.value

      this.$router.push({
        name: 'Summoner',
        params: {
          region,
          name,
        },
      })
    },
    doNothing () {
    },
  },
}
</script>


<style lang="sass">
@import '../sass/variables'
@import '~vue-blu/src/scss/elements/popover'

.summoner-search--center
  justify-content: center !important

.summoner-search--large
  .summoner-search__search-container
    flex-shrink: 1
    flex-basis: 280px
  .summoner-search__search-field
    width: 100%
  .summoner-search__region-switcher,
  .summoner-search__search-field
    height: 3.5em
    padding: calc(1em - 1px)

.summoner-search .icon
  margin-right: 14px
  svg
    height: 1rem
    fill: currentColor

.summoner-search__search-field
  background: $navbar-background-light
  border: none
  color: white
  box-shadow: none

.summoner-search__search-field::placeholder
  color: rgba(white, .5)

.field.summoner-search > .control
  margin-right: 0px
  margin-bottom: 0px

.is-dark
  .summoner-search__search-field
    background: rgba(0,0,0,.25)
  
</style>




// WEBPACK FOOTER //
// SummonerSearch.vue?7abdbf36